import { Pipe, PipeTransform } from '@angular/core';
import { PromoDepth } from '../Model/PromoDepth.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'PromoDepthFilter',
  standalone: false
})
export class PromoDepthFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(promoDepths: PromoDepth[], searchTerm: string, field: string): PromoDepth[] {
    if (!promoDepths || !searchTerm) return promoDepths;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return promoDepths.filter(promo => this.matchesSearchTerm(promo, lowerSearchTerm));
  }

  private matchesSearchTerm(promo: PromoDepth, term: string): boolean {
    const fieldsToCheck: (keyof PromoDepth | { dateField: keyof PromoDepth })[] = [
      'MarketCompanyName',
      'label',
      'UserName',
      'max',
      'min',
      { dateField: 'applicationDate' }
    ];

    return fieldsToCheck.some(field => {
      if (typeof field === 'string') {
        const value = promo[field];
        return value != null && value.toString().toLowerCase().includes(term);
      }

      const dateValue = promo[field.dateField];
      if (!dateValue) return false;

      const formattedDate = this.datePipe.transform(dateValue as string | number | Date, 'MMMM dd, yyyy');
      return formattedDate?.toLowerCase().includes(term) || false;
    });
  }

}
